import { ISource } from '@shared/types/source';

import { PaymentPlan__PaymentMethodFragment as PaymentPlanSource } from '@portal/schema';

export const displayableSource = (source: ISource | PaymentPlanSource) => `${source.brand} ending in ${source.number}`;
